const {recordDiagnostic} = require('./diagnostics');

const OBSERVABLE_PROVIDER_EVENTS = new Set([
    'AddPaymentInfo',
    'AddToCart',
    'InitiateCheckout',
    'Lead',
    'PageView',
    'Purchase',
    'Search',
    'SubscribedButtonClick',
    'ViewContent',
    'add_payment_info',
    'add_to_cart',
    'begin_checkout',
    'change_currency',
    'click',
    'first_visit',
    'generate_lead',
    'page_view',
    'purchase',
    'remove_from_cart',
    'scroll',
    'select_item',
    'session_start',
    'user_engagement',
    'user_info',
    'view_cart',
    'view_item',
    'view_item_list',
]);

let resourceObserver = null;

function normalizeProviderEventName(value) {
    return OBSERVABLE_PROVIDER_EVENTS.has(value) ? value : 'other';
}

function classifyAnalyticsRequest(resourceName) {
    try {
        const resourceUrl = new URL(resourceName);
        const hostname = resourceUrl.hostname;
        const isGoogleAnalyticsHost = hostname === 'google-analytics.com' ||
            hostname.endsWith('.google-analytics.com');
        const isFirstPartyGoogleAnalyticsEndpoint = hostname === window.location.hostname &&
            resourceUrl.pathname.startsWith('/metrics/') &&
            resourceUrl.pathname.includes('/g/collect');

        if ((hostname === 'facebook.com' || hostname.endsWith('.facebook.com')) &&
            resourceUrl.pathname.startsWith('/tr')) {
            return {
                eventName: normalizeProviderEventName(resourceUrl.searchParams.get('ev')),
                stage: 'meta_request_observed',
            };
        }

        if ((isGoogleAnalyticsHost || isFirstPartyGoogleAnalyticsEndpoint) &&
            resourceUrl.pathname.includes('/g/collect')) {
            return {
                eventName: normalizeProviderEventName(resourceUrl.searchParams.get('en')),
                stage: 'ga_request_observed',
            };
        }
    } catch (error) {
        return null;
    }

    return null;
}

function observeAnalyticsRequests() {
    if (resourceObserver !== null) {
        return;
    }

    if (typeof window.PerformanceObserver !== 'function') {
        recordDiagnostic('resource_observer_unavailable', {
            source: 'performance_observer',
        });
        return;
    }

    resourceObserver = new window.PerformanceObserver(function (list) {
        list.getEntries().forEach(function (resource) {
            const request = classifyAnalyticsRequest(resource.name);

            if (request) {
                recordDiagnostic(request.stage, {
                    eventName: request.eventName,
                    source: 'performance_observer',
                });
            }
        });
    });

    try {
        resourceObserver.observe({buffered: true, type: 'resource'});
        recordDiagnostic('resource_observer_started', {
            source: 'performance_observer',
        });
    } catch (error) {
        try {
            resourceObserver.observe({entryTypes: ['resource']});
            recordDiagnostic('resource_observer_started', {
                source: 'performance_observer',
            });
        } catch (fallbackError) {
            resourceObserver = null;
            recordDiagnostic('resource_observer_unavailable', {
                source: 'performance_observer',
            });
        }
    }
}

module.exports = {
    observeAnalyticsRequests,
};
